import React, { useState, useCallback } from "react";
import { CategoryType, CreateProductType } from "../../types";
import { useGetCategoryQuery } from "../../../../../hooks/CategoryManagement/useGetCategoryQuery";
import Loader from "Components/Loader";

type DropdownProps = {
  placeholder: string;
  payload: CreateProductType;
  setPayload: React.Dispatch<React.SetStateAction<CreateProductType>>;
};

const EditDropdown: React.FC<DropdownProps> = ({
  placeholder,
  setPayload,
  payload,
}) => {
  const [active, setActive] = useState(false);
  const { data, isLoading } = useGetCategoryQuery({});

  const toggleDropdown = useCallback(() => {
    setActive((prevActive) => !prevActive);
  }, []);

  const handleCategoryChange = (category: CategoryType) => {
    setPayload((prevPayload: any) => {
      const isSelected = prevPayload.categories.some(
        (cat: any) => cat.id === category.id
      );
      const newCategories = isSelected
        ? prevPayload.categories.filter((cat: any) => cat.id !== category.id)
        : [...prevPayload.categories, { name: category.name, id: category.id }];

      return { ...prevPayload, categories: newCategories };
    });
  };

  return (
    <div className="relative mt-[13px]">
      <div
        className={`bg-offwhite p-[20px] cursor-pointer px-6 py-4 bg-white mb-[15px] w-full border-[1px] ease-in-out duration-300 focus:border-orange rounded-md ${
          active ? "border-orange" : "border-[#d3d3d3]"
        }`}
        onClick={toggleDropdown}
      >
        <span className="flex justify-between">
          <span className="text-syd truncate">{placeholder}</span>
          {active ? <UpChevron /> : <DownChevron />}
        </span>
      </div>

      {active && (
        <div className="z-10 w-full absolute top-[70px] h-[200px] overflow-y-scroll border-[1px] border-orange bg-white rounded-[10px] px-[30px] pt-[30px]">
          {!data && isLoading && <div className="loader"></div>}
          {data?.data?.docs &&
            data.data.docs.map((category: CategoryType) => (
              <div key={category.id} className="flex items-center">
                <input
                  type="checkbox"
                  id={category.id}
                  checked={payload.categories.some(
                    (cat: any) => cat.id === category.id
                  )}
                  onChange={() => handleCategoryChange(category)}
                  className="mr-2"
                />
                <label htmlFor={category.id}>{category.name}</label>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default EditDropdown;

const UpChevron = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 15.75 7.5-7.5 7.5 7.5"
    />
  </svg>
);

const DownChevron = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19.5 8.25-7.5 7.5-7.5-7.5"
    />
  </svg>
);
